import { useState } from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import RefreshIcon from '@mui/icons-material/Refresh';

import { useLocalization } from 'localization';

type QueryKey = readonly unknown[];

type Props = IconButtonProps & {
  onRefetch?: () => void;
  queryKey?: QueryKey[] | (() => QueryKey[]);
};

const RefreshButton = (props: Props) => {
  const { onRefetch, queryKey, size = 'medium', ...buttonProps } = props;
  const { t } = useLocalization();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      const keys: QueryKey[] = typeof queryKey === 'function' ? queryKey() : queryKey ?? [];
      onRefetch?.();
      await Promise.all(keys.map(key => queryClient.invalidateQueries({ queryKey: key })));
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setIsRefreshing(false);
    }
  };
  return (
    <Tooltip title={t('common.terms.refreshData')} placement="top">
      <IconButton sx={{ width: 'fit-content' }} {...buttonProps} onClick={handleRefresh} loading={isRefreshing}>
        <RefreshIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default RefreshButton;
